import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITaskDelayFailure } from '../../../../interfaces/delay-failure/task-delay-failure';
import { DelayFailureService, EventService, IJobScreenEvent } from '../../../../services';

@Component({
  selector: 'job-screen-delay-failures-table',
  templateUrl: './job-screen-delay-failures-table.component.html',
  styleUrls: ['./job-screen-delay-failures-table.component.scss'],
})
export class JobScreenDelayFailuresTableComponent implements OnInit, OnDestroy {
  @Input() jobId!: number;
  @Input('organisationId') organisationId!: number;
  @Input('organisationTypeId') organisationTypeId!: number;

  subscriptions: Subscription[] = [];

  delayFailures: ITaskDelayFailure[];

  loading = false;

  constructor(
    private eventService: EventService,
    private delayFailureService: DelayFailureService,
  ) {}

  ngOnInit(): void {
    this.load();

    this.subscriptions.push(
      this.eventService.DelayFailureRefreshEvent.subscribe(() => {
        this.load();
      }),
    );

    this.subscriptions.push(
      this.eventService.JobScreenEvent.subscribe((event) => {
        this.handleEvents(event);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => x?.unsubscribe());
  }

  load() {
    this.loading = true;
    this.delayFailureService
      .getJobDelayFailures(this.jobId)
      .then((res) => {
        this.delayFailures = res;
        this.loading = false;
      })
      .catch((err) => {
        console.log('Error Loading Delay/Failures: ', err);
        this.loading = false;
      });
  }

  private handleEvents(event: IJobScreenEvent) {
    if (event.event == 'refresh-incidents') {
      this.load();
    }
  }
}
